import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { Card, Button, Container, Row, Col, Spinner } from 'react-bootstrap';

const QuestionsEx = () => {
  const [questions, setQuestions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async (page = 1) => {
    setLoading(true);
    const loggedInUser = localStorage.getItem("loggedInUser");
    const token = localStorage.getItem("authToken");
    const programType = "getQuestionDetailsMain";
    const limit = "10";

    try {
      const fd = new FormData();
      fd.append("programType", programType);
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("limit", limit);
      fd.append("page", page); // if backend supports page

      const response = await api.post("question/questionCurl", fd);
      const questionData = response.data;

      if (page === 1) {
        setQuestions(questionData.questions || []);
      } else {
        setQuestions((prev) => [...prev, ...(questionData.questions || [])]);
      }

      setCurrentPage(page);
      setTotalPages(questionData.totalPages);
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(1);
  }, []);

  const handleLoadMore = () => {
    fetchData(currentPage + 1);
  };

  return (
    <Container className="py-4">
      <h3 className="mb-4">Questions</h3>

      <Row>
        {questions.map((q, idx) => (
          <Col md={6} lg={4} className="mb-4" key={q.id || idx}>
            <Card>
              <Card.Body>
                <Card.Title>Question ID: {q.id}</Card.Title>
                <Card.Text>
                  <strong>Subject:</strong> {q.subjectId} <br />
                  <strong>Chapter:</strong> {q.chapterId} <br />
                  <strong>Topic:</strong> {q.topicId}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {currentPage < totalPages && (
        <div className="text-center">
          <Button variant="primary" onClick={handleLoadMore} disabled={loading}>
            {loading ? <Spinner animation="border" size="sm" /> : 'Load More'}
          </Button>
        </div>
      )}
    </Container>
  );
};

export default QuestionsEx;
